import { render, staticRenderFns } from "./PrivilegeReport.vue?vue&type=template&id=e7f8e4fa&"
import script from "./PrivilegeReport.vue?vue&type=script&lang=js&"
export * from "./PrivilegeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports